import { Button } from "reactstrap";
import { SUBCATEGORIESTOTALS } from "../../navigation/Routes";

export const prepareOrgVersion = (list = []) => {
  return list.map((item) => {
    const organization_desc = item.organization.description;
    const instCode = item.organization.instituteCode;
    const orgVersionId = item.id;
    const organizationId = item.organization.id;
    const isExternal = item.organization.isExternal;
    const internProjectId = item.version.project.id;
    const projectVersionId = item.version.id;
    const parent = item.parent;
    const projectInfo = { ...item.version.project };
    const structureInfo = { ...item.version.project.structure };
    return {
      ...item,
      ...projectInfo,
      ...structureInfo,
      organization: organization_desc,
      projectVersionId: projectVersionId,
      orgVersionId: orgVersionId,
      instCode: instCode,
      parent: parent,
      organizationId: organizationId,
      isExternal: isExternal,
      internProjectId: internProjectId,
    };
  });
};

export const toSubCategoryList = (project, navigate) => {
  navigate(
    `${SUBCATEGORIESTOTALS}/${project.orgVersionId}/${project.structure.id}`,
    {
      state: {
        status: project.status,
        isCloned: !!project.parent,
        projectCode: project.code,
        projectId: project.internProjectId,
        projectYear: project.year,
        externalProjectId: project.projectId,
        organizationId: project.organizationId,
        isExternal: project.isExternal,
        structureInfo: project.structure,
        orgVersionInstCode: project.instituteCode,
        instituteDescription: project.organization,
        coFinancing: project.coFinancing,
        projectStatus: project.status,
      },
    }
  );
};

export const filterOrgVersionList = (list) => {
  const groupedByOrg = list.reduce(function (accumulator, currentItem) {
    let key;
    // ignore already consolidated and verified projects
    if (currentItem.status === "VERIFIED") {
      key = `v__${currentItem["organization"]}`;
    } else if (currentItem.status === "SNAPSHOTTED") {
      key = `s__${currentItem["organization"]}`;
    } else {
      key = currentItem["organization"];
    }
    if (!accumulator[key]) {
      accumulator[key] = [];
    }
    accumulator[key].push(currentItem);
    return accumulator;
  }, {});

  const filtered = Object.values(groupedByOrg)
    .map((item) =>
      item.reduce(function (r, a) {
        return r.lastModifiedDate > a.lastModifiedDate ? r : a;
      })
    )
    .sort((a, b) =>
      b.status.toUpperCase().localeCompare(a.status.toUpperCase())
    );

  return filtered;
};

export const getCategoryColumn = (label, navigate) => ({
  Header: "",
  accessor: "category",
  enableColumnFilter: false,
  sortable: false,
  Cell: ({ row }) => (
    <Button
      color={"info"}
      onClick={() => toSubCategoryList(row.original, navigate)}
    >
      {label}
    </Button>
  ),
});
